import { RemoteCollectionStore } from '@softline/core'
import {Aktivitaet} from '../types/aktivitaet';

export const AktivitaetenStore = RemoteCollectionStore.create<Aktivitaet>();
